import { useParams } from 'react-router-dom';

import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { LoadingIndicator } from '@sorare/core/src/atoms/loader/LoadingIndicator';

import { Articles } from 'components/Articles';
import { Breadcrumb } from 'components/Breadcrumb';
import { useSection } from 'hooks/zendesk';

const Section = () => {
  const { sectionId } = useParams();
  const { category, section } = useSection(sectionId);

  if (!section || !category) {
    return <LoadingIndicator fullHeight />;
  }

  return (
    <Vertical gap={3}>
      <Breadcrumb category={category} />
      <Articles section={section} />
    </Vertical>
  );
};

export default Section;
